/**
 * Compact, axis-less line chart used inside the KPI cards.
 *
 * Hand-rolled SVG (no Recharts) because:
 * - 80x24 px doesn't justify a ResponsiveContainer round-trip
 * - we only ever draw one polyline; Recharts' overhead would dwarf the
 *   actual paint cost
 *
 * Trend direction colours the stroke green or red — `invert` flips that
 * for metrics where a downward trend is good (e.g. response time).
 */
import { SparklineStyles } from "./sparkline.styles";

const Sparkline = ({
  values = [],
  width = 80,
  height = 24,
  invert = false
}) => {
  if (!values || values.length < 2) {
    // Nothing meaningful to render — keep the slot to avoid layout shift.
    return <SparklineStyles style={{ width, height }} />;
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = Math.max(0.0001, max - min);

  const x = i => (i / Math.max(1, values.length - 1)) * (width - 2) + 1;
  const y = v => height - 2 - ((v - min) / range) * (height - 4);
  const points = values.map((v, i) => `${x(i)},${y(v)}`).join(" ");

  const trendUp = values[values.length - 1] > values[0];
  const positive = invert ? !trendUp : trendUp;
  const stroke = positive ? "#292359" : "#A31717";

  return (
    <SparklineStyles>
      <svg width={width} height={height} aria-hidden="true">
        <polyline
          points={points}
          fill="none"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SparklineStyles>
  );
};

export default Sparkline;
